import { PromiseAjaxWrapper } from '../../lib/ajax/promise-ajax-wrapper';
import { axiosWrapper } from '../../lib/axios-wrapper/axios-wrapper';
import { satGlobals } from '../../qaamgo/sat/helper/sat-globals';
import { csrfManager } from '../csrf/csrf-manager';
import { apiRequestManager } from './api-request-manager';

class PresetApi {
    constructor() {
        this.ajax = new PromiseAjaxWrapper();
    }

    postPreset(presetData) {
        const endpoint = '/api/presets';

        return csrfManager
            .getCsrfPreset()
            .then((token) => {
                presetData._csrf = token;

                return apiRequestManager.post(endpoint, presetData);
            })
            .then((/** AxiosResponse */ response) => {
                return Promise.resolve(response?.data);
            });
    }

    getPersonalPresets() {
        const endpoint = '/api/presets/personal';

        const data = {};

        return apiRequestManager.get(endpoint, data);
    }

    getGlobalPresetsForTarget(target) {
        const endpoint = '/api/presets/global';

        const data = {
            target: target,
        };

        return apiRequestManager.get(endpoint, data);
    }

    deletePreset(presetId) {
        const endpoint = `/api/presets/personal/delete`;

        const data = {
            id: presetId,
        };

        return csrfManager.getCsrfPreset().then((token) => {
            data._csrf = token;
            return apiRequestManager.post(endpoint, data);
        });
    }

    patchPreset(presetId, presetData) {
        const endpoint = `/api/presets/personal/patch`;

        const data = {
            id: presetId,
            category: presetData.category,
            target: presetData.target,
            name: presetData.name,
            options: presetData.options,
        };

        return csrfManager.getCsrfPreset().then((token) => {
            data._csrf = token;
            return apiRequestManager.post(endpoint, data);
        });
    }
}

export { PresetApi };
